import { defineStore } from 'pinia';
import { getSellerOrderList } from '@/api/point';

interface PointListState {
  checked: number[]
}

export const usePointList = defineStore({
  id: 'seller-point-list',
  state: (): PointListState => ({
    checked: [],
  }),
  getters: {},
  actions: {
    async getPointListData(page: number, pageSize: number) {
      return getSellerOrderList({
        page: page.toString(),
        limit: pageSize.toString(),
        type: '',
        create_time: '',
      }).then((res: any) => {
        this.checked = [];
        return { list: res?.data || [], total: res?.total || 0 };
      });
    },
  },
});
